import { Route } from '../../../core/utils/RouteMixins';
import Pages from '../../../config/Pages';
import Listagem from './IndicadorSolicitacoesListagem';
import Form from './indicadorSolicitacoesForm/IndicadorSolicitacoesForm';
import { permissionEnums } from '../../../core/enums/PermissionEnums';

const indicadorSolicitacoesRoutes = [
    Route(
        ['Solitações Ativar/Inativar Indicador', 'pi pi-flag'],
        Pages.sei.indicadorSolicitacoes.url.list,
        Listagem,
        [permissionEnums.INDICADOR_SOLICITACOES_VISUALIZAR]
    ),
    Route(null, Pages.sei.indicadorSolicitacoes.url.edit, Form, [
        permissionEnums.INDICADOR_SOLICITACOES_EDITAR,
    ]),
    Route(null, Pages.sei.indicadorSolicitacoes.url.view, Form, [
        permissionEnums.INDICADOR_SOLICITACOES_EDITAR,
    ]),
];

export default indicadorSolicitacoesRoutes;
